import { render, staticRenderFns } from "./customerTag.vue?vue&type=template&id=7412f06a&scoped=true&"
import script from "./customerTag.vue?vue&type=script&lang=js&"
export * from "./customerTag.vue?vue&type=script&lang=js&"
import style0 from "./customerTag.vue?vue&type=style&index=0&id=7412f06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412f06a",
  null
  
)

export default component.exports